import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export interface SidebarContextInterface {
  isCollapsed: boolean;
  setIsCollapsed: Dispatch<SetStateAction<boolean>>;
  isSeasonalEffectEnabled: boolean;
  setIsSeasonalEffectEnabled: Dispatch<SetStateAction<boolean>>;
}

export const SidebarContext = createContext<SidebarContextInterface>({} as SidebarContextInterface);

export const useSidebarContext = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('Trying to access sidebarContext outside of SidebarContextProvider');
  }
  return context;
};
